// extracted by mini-css-extract-plugin
export default {"footer":"styles__footer___INaIC","inner":"styles__inner___lqhab","focus-visible":"styles__focus-visible___jLE_k"};